































import { defineComponent, ref } from '@vue/composition-api';
import svgCom from '@components/Svg/index';
import { verificaPsw } from '@/useable/verification';
import { Message } from 'element-ui';

export default defineComponent({
  name: 'PwdInput',
  components: {
    svgCom,
  },
  model: {
    prop: 'password',
    event: 'update:password',
  },
  props: {
    password: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入密码',
    },
  },
  setup(prop: any) {
    const type = ref('password');
    const iconState = ref(true);

    const toggleType = () => {
      type.value = type.value === 'text' ? 'password' : 'text';
    };

    const validatePassword = () => {
      if (!verificaPsw(prop.password)) {
        Message.error('密码应该为大小写字母、数字组合或特殊字符任意三种，8至位15位！');
        return false;
      } 
      return true;
    };

    return {
      type,
      toggleType,
      iconState,
      validatePassword,
    };
  },
});
